import React from 'react';
import { useSelector } from 'react-redux';
import MedicoLayout from '../components/medico/MedicoLayout';
import PacienteLayout from '../components/paciente/PacienteLayout';

const AppShell = ({ children }) => {
  const signed = useSelector(state => state.patient.signed);
  const profile = useSelector(state => state.doctor.profile);
  const { logado } = useSelector(state => state.funcionario);

  if (signed) {
    return <PacienteLayout>{children}</PacienteLayout>;
  }

  if (profile || logado) {
    return <MedicoLayout>{children}</MedicoLayout>;
  }

  return children;
};

export default AppShell;
